import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material';

const RiskReportDocLight = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 60 55.596" {...props}>
      <defs>
        <clipPath id="a">
          <path fill="none" d="M0 0h60v55.596H0z" data-name="Rectangle 5908" />
        </clipPath>
      </defs>
      <g data-name="Group 16778" style={{ isolation: 'isolate' }}>
        <g clipPath="url(#a)" data-name="Group 16777">
          <path
            fill="#cfddea"
            d="M60 25A23 23 0 1 1 37 2a23 23 0 0 1 23 23"
            data-name="Path 7658"
          />
          <path fill="#8990a7" d="M9 1 1 9v44h35V1Z" data-name="Path 7659" />
          <path
            fill="#8990a7"
            d="m49.51 50.475-12.9-12.9-3.536 3.536 12.9 12.9a2 2 0 0 0 2.828 0l.707-.707a2 2 0 0 0 0-2.828"
            data-name="Path 7660"
          />
          <path fill="#8990a7" d="M1 10h9V1H9L1 9Z" data-name="Path 7661" />
          <path
            fill="#fff"
            stroke="#21549d"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M36 13V1H9L1 9v44h35v-4"
            data-name="Path 7662"
          />
          <path
            fill="#8195bc"
            stroke="#21549d"
            strokeMiterlimit="10"
            strokeWidth="2"
            d="m36.611 37.575 12.9 12.9a2 2 0 0 1 0 2.829l-.707.707a2 2 0 0 1-2.828 0l-12.9-12.9"
            data-name="Path 7663"
          />
          <rect
            width="4"
            height="6"
            fill="#fff"
            stroke="#21549d"
            strokeMiterlimit="10"
            strokeWidth="2"
            data-name="Rectangle 5900"
            rx="1"
            transform="translate(45 7.5)"
          />
          <rect
            width="4"
            height="6"
            fill="#fff"
            stroke="#21549d"
            strokeMiterlimit="10"
            strokeWidth="2"
            data-name="Rectangle 5901"
            rx="1"
            transform="translate(45 31)"
          />
          <path
            fill="none"
            stroke="#21549d"
            strokeMiterlimit="10"
            strokeWidth="2"
            d="M56 21v8"
            data-name="Line 9"
          />
          <path
            fill="#8990a7"
            d="M40 28a16 16 0 1 1-16-16 16 16 0 0 1 16 16"
            data-name="Path 7664"
          />
          <circle
            cx="16"
            cy="16"
            r="16"
            fill="#8195bc"
            stroke="#21549d"
            strokeMiterlimit="10"
            strokeWidth="2"
            data-name="Ellipse 343"
            transform="translate(8 12)"
          />
          <path fill="#8990a7" d="M16 28h5v7h-5z" data-name="Rectangle 5902" />
          <path
            fill="#fff"
            stroke="#21549d"
            strokeMiterlimit="10"
            strokeWidth="2"
            d="M16 28h5v7h-5z"
            data-name="Rectangle 5903"
          />
          <path fill="#8990a7" d="M21 21h5v14h-5z" data-name="Rectangle 5904" />
          <path
            fill="#fff"
            stroke="#21549d"
            strokeMiterlimit="10"
            strokeWidth="2"
            d="M21 21h5v14h-5z"
            data-name="Rectangle 5905"
          />
          <path fill="#8990a7" d="M26 25h5v10h-5z" data-name="Rectangle 5906" />
          <path
            fill="#fff"
            stroke="#21549d"
            strokeMiterlimit="10"
            strokeWidth="2"
            d="M26 25h5v10h-5z"
            data-name="Rectangle 5907"
          />
          <path
            fill="#8195bc"
            stroke="#21549d"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M5 10h5V5"
            data-name="Path 7665"
          />
        </g>
      </g>
    </SvgIcon>
  );
};

export default RiskReportDocLight;
